export const actions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    SHOW_ERROR: 'SHOW_ERROR',
    HIDE_ERROR: 'HIDE_ERROR',
};
